import { makeRoute } from "@flow/common/route";
import * as Safe from "safe-portals";
import { Serializers } from "@flow/common/types";
import { ShareTypeSerializer, StatsSerializer } from "../common/types";

export const recordShareAction = makeRoute(
  "/api/plugin/social_share/record_share_action",
  "public",
  Safe.obj({
    context: Serializers.journeyContext,
    action_guid: Safe.str,
    share_type: ShareTypeSerializer,
  }),
  Safe.nothing
);

export const getActionShareStats = makeRoute(
  "/admin/api/plugin/social_share/get_action_share_stats",
  [],
  Safe.obj({
    action_guid: Safe.str,
  }),
  StatsSerializer
);
// frontend to backend
